<template>
  <div class="user-avatar-dropdown">
    <Dropdown @on-click="handleClick">
      <Badge :dot="!!messageUnreadCount">
        <!--<Avatar :src="userAvatar"/>-->
        <span>{{userInfo.name}}</span>
      </Badge>
      <Icon :size="18" type="md-arrow-dropdown"></Icon>
      <DropdownMenu slot="list">
        <!--
        <DropdownItem name="message">
          消息中心<Badge style="margin-left: 10px" :count="messageUnreadCount"></Badge>
        </DropdownItem> -->
        <DropdownItem name="modify">修改密码</DropdownItem>
        <DropdownItem name="logout">退出登录</DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <ModifyPass ref="modifyRef" />
  </div>
</template>

<script>
import './user.less'
import { mapActions } from 'vuex'
import ModifyPass from './ModifyPassword'
export default {
  name: 'User',
  components: {
    ModifyPass
  },
  props: {
    userAvatar: {
      type: String,
      default: ''
    },
    messageUnreadCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    ...mapActions([
      'handleLogOut'
    ]),
    logout () {
      this.handleLogOut().then(() => {
        this.$router.push({
          name: 'login'
        })
      })
    },
    modify () {
      this.$refs['modifyRef'].modifyStatus = true
    },
    handleClick (name) {
      switch (name) {
        case 'logout': this.logout()
          break
        case 'modify': this.modify()
          break
      }
    }
  }
}
</script>
